export default {
    name: "LandingPageCalculate",
    data() {
        return {
            puppyPrice: "",
            perWeekPrice: 0,
            storeCredit: process.env.VUE_APP_STORE_CREDIT,
        };
    },
    methods: {
    },
};
